// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1fe521cf","337":"441021b7","453":"70800742","455":"3fcfa94e"}[chunkId] + ".chunk.js";
};